export enum MediaPlayerProvider {
    Default = 'default',
    Youtube = 'youtube'
}
